import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { UserDto } from '../models/user/create-user-dto';
import { first, merge, Observable, of, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HTTP_ENDPOINTS } from '../external/http';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  private users: UserDto[] = [];
  private users$: EventEmitter<UserDto[]> = new EventEmitter();
  private fetchUsersSubscription?: Subscription;

  constructor(private http: HttpClient) { }

  public createUser(createUserDto: UserDto): Observable<UserDto> {
    return this.http.post<UserDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.USERS_BASE_PATH}`, createUserDto)
      .pipe(first());
  }

  public fetchUsers(): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.USERS_BASE_PATH}`)
    .pipe(first());
  }

  public getUsers$(): Observable<UserDto[]> {
    if (this.users.length > 0) return merge(of(this.users), this.users$);
        
        return this.users$;
  }

  public refreshUsers(): void {
    this.fetchUsersSubscription?.unsubscribe();
    this.fetchUsersSubscription = this.fetchUsers()
      .subscribe(users => {
        this.users = users;
        this.users$.emit(this.users);
      })
  }

  public deleteUser(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.USERS_BASE_PATH}/${id}`)
    .pipe(first());
  }
}
